import { useQuery } from '@tanstack/react-query';

import { PrependUrl } from 'enums';
import { fetchWithCsrfToken } from 'utils/fetchWrapper';

export interface Reminder {
  rule: string;
  days: number;
}

export interface AssessmentEmailSettings {
  has_auto_reminders: boolean;
  has_rolling_applicant_deadline: boolean;
  allow_applicant_notifications: boolean;
  closed_date: string | null;
  reminders: Reminder[];
}

const useGetAssessmentEmailSettings = (interviewUid: string) => {
  const { data, isLoading } = useQuery<AssessmentEmailSettings, Error>(
    ['getAssessmentEmailSettings', interviewUid],
    async () =>
      fetchWithCsrfToken<AssessmentEmailSettings>(
        `${PrependUrl.ASYNC}/assessment/get_email_settings`,
        'POST',
        { interview: interviewUid }
      ),
    {
      enabled: !!interviewUid,
    }
  );

  return {
    data,
    isLoading,
  };
};

export default useGetAssessmentEmailSettings;
